import { render, staticRenderFns } from "./ListKendaraanDerekPage.vue?vue&type=template&id=f03e8d78&scoped=true"
import script from "./ListKendaraanDerekPage.vue?vue&type=script&lang=js"
export * from "./ListKendaraanDerekPage.vue?vue&type=script&lang=js"
import style0 from "./ListKendaraanDerekPage.vue?vue&type=style&index=0&id=f03e8d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03e8d78",
  null
  
)

export default component.exports